import { render, staticRenderFns } from "./RetailStrataRetailSpace.vue?vue&type=template&id=8f07c1b6&scoped=true&"
import script from "./RetailStrataRetailSpace.vue?vue&type=script&lang=ts&"
export * from "./RetailStrataRetailSpace.vue?vue&type=script&lang=ts&"
import style0 from "./RetailStrataRetailSpace.vue?vue&type=style&index=0&id=8f07c1b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f07c1b6",
  null
  
)

export default component.exports